// import React, { useEffect, useMemo, useState, useCallback } from "react";
// import { ReactComponent as Back } from "../../../../assets/svgs/back-button.svg";
// import { ReactComponent as FilterIcon } from "../../../../assets/svgs/filters-icon.svg";
// import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// import { Button } from "antd";
// import { Tables } from "../../../../components/Elements/Tables/Tables";
// import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-green.svg";
// import { Badge } from "../../../../components/Elements/TextStyles/Badge";
// import CreateProjects from "./DailogBoxes/CreateProjects";
// import ProjectFilter from "./DailogBoxes/ProjectFilter";
// import { useNavigate } from "react-router-dom";
// import { getApi } from "../../../../api/api_instance";
// import { API_URLS } from "../../../../api/apiUrls";
// import dayjs from "dayjs";
// import { IoArrowBackCircleOutline } from "react-icons/io5";
// import { useSearchParams, useLocation } from "react-router-dom";
// import { THEME_COLORS } from "../../../../color.js";

// const OrganizationProjects = () => {

//   const [openCreateDialog, setOpenCreateDialog] = useState(false);
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [sortOrder, setSortOrder] = useState("-createdAt");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterData, setFilterData] = useState("");
//   const [searchParams] = useSearchParams();
//   const openModal = searchParams.get("openModal") === "true";

//   const navigate = useNavigate();
//   const location = useLocation();
//   const headers = useMemo(
//     () => [
//       { label: "Sr. No.", key: "serial" },
//       { label: "Project name", key: "projectName" },
//       { label: "Start date", key: "startDate" },
//       { label: "End Date", key: "endDate" },
//       { label: "Project type", key: "projectType" },
//       { label: "Status", key: "status" },
//       { label: "Action", key: "action" },
//     ],
//     [],
//   );

//   const fetchTableData = useCallback(async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_PROJECTS(
//           currentPage,
//           pageSize,
//           sortOrder,
//           searchTerm,
//           filterData,
//         ),
//       });

//       if (response.success) {
//         setPageSize(response.limit);
//         setTotalRecords(response.total);
//         setTableData(
//           response.data.map((item, index) => ({
//             key: item._id,
//             serial: (currentPage - 1) * response.limit + index + 1,
//             projectName: item.name,
//             startDate: dayjs(item.startDate).format("DD/MM/YYYY"),
//             endDate: dayjs(item.endDate).format("DD/MM/YYYY"),
//             projectType: item.project_type,
//             status: <Badge text={item.status} />,
//             action: (
//               <EditIcon
//                 style={{
//                   fontSize: "18px",
//                   cursor: "pointer",
//                   color: "#0087A3",
//                 }}
//                 onClick={() => handleForm(item)}
//               />
//             ),
//           })),
//         );
//       }
//     } catch (error) {
//       console.error("Error in fetching table data", error);
//     }
//   }, [currentPage, pageSize, sortOrder, searchTerm, openCreateDialog]);

//   const handleForm = useCallback(
//     (item) => {
//       navigate("/organization/projects/projectPage", {
//         state: { projectName: item.name, projectId: item._id },
//       });
//     },
//     [navigate],
//   );

//   const handleSort = useCallback(() => {
//     setSortOrder((prevOrder) =>
//       prevOrder === "createdAt" ? "-createdAt" : "createdAt",
//     );
//   }, []);

//   const handlePageChange = useCallback((page) => {
//     setCurrentPage(page);
//   }, []);

//   useEffect(() => {
//     fetchTableData();
//   }, [fetchTableData]);

//   useEffect(() => {
//     if (openModal) {
//       setOpenCreateDialog(true);
//       const newSearchParams = new URLSearchParams(searchParams);
//       newSearchParams.delete("openModal");
//       // Use current pathname and cleaned query
//       navigate(`${location.pathname}?${newSearchParams.toString()}`, {
//         replace: true,
//       });
//     }
//   }, [openModal]);

//   return (
//   <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       <div>
//         <div
//           className="flex justify-end  text-[1rem]"
//           style={{ fontFamily: "Calibri" }}
//         >
//           <p>Home</p>
//           <span> / </span>
//           <p style={{color:THEME_COLORS.green}}> Projects</p>
//         </div>
//         <div className="flex mb-2  gap-2 text-xl  font-bold">
//           <div>
//             <IoArrowBackCircleOutline className=" w-10 h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition duration-200" />
//           </div>

//           <div

//             className="text-[#06513D] mt-2 font-[Calibri] font-bold text-[20px] leading-[100%] tracking-[0]
// "
//           >
//             {" "}
//             Projects
//           </div>
//         </div>

//         <div
//           style={{
//             border: "1px solid #3BA2B959",
//             borderRadius: "10px",
//             paddingTop: "20px",
//             boxShadow: "0px 0px 16px 0px #3BA2B91F",
//             backgroundColor:"white"
//           }}
//         >
//           <div className="flex justify-between mb-4 px-6">
//             <div className="flex gap-4">
//               <div
//                 style={{
//                   background: "#E6EEEC",
//                   height: "40px",
//                   border: "1px solid #0087A3",
//                   color: "#005E45",
//                 }}
//                 className="px-4 rounded-md text-gray-400 text-base font-light"
//               >
//                 <p
//                   style={{
//                     fontFamily: "Calibri",
//                     fontWeight: "300",
//                     fontSize: "16px",
//                     lineHeight: "24px",
//                     letterSpacing: "0%",
//                   }}
//                   className="pt-2"
//                 >
//                   TOTAL PROJECTS {totalRecords}
//                 </p>
//               </div>
//               <SearchBar
//                 width="300px"
//                 onSearch={(value) => setSearchTerm(value)}
//               />
//             </div>
//             <div className="flex gap-4">
//               <Button
//                 type="primary"
//                 style={{ background: "#06513D" }}
//                 className="text-[12px] font-light px-2 py-5"
//                 onClick={() => setOpenCreateDialog(true)}
//               >
//                 + CREATE PROJECT
//               </Button>
//               <Button
//                 style={{ background: "#E6EEEC", border: "solid 1px #06513D" }}
//                 className="text-[12px] text-[#06513D] font-[Calibri]  font-light px-4 py-5"
//                 onClick={() => setFilterOpen(true)}
//               >
//                 <FilterIcon /> FILTER
//               </Button>
//             </div>
//           </div>
//           <Tables
//             data={tableData}
//             headers={headers}
//             pageSize={pageSize}
//             total={totalRecords}
//             current={currentPage}
//             onChange={handlePageChange}
//             onSort={handleSort}
//           />
//         </div>
//         {openCreateDialog && (
//           <CreateProjects
//             onOpen={openCreateDialog}
//             onClose={() => setOpenCreateDialog(false)}
//           />
//         )}
//         {filterOpen && (
//           <ProjectFilter
//             onOpen={filterOpen}
//             onClose={() => setFilterOpen(false)}
//             setFilterData={setTableData}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default OrganizationProjects;

// import React, { useEffect, useMemo, useState, useCallback } from "react";
// import { ReactComponent as FilterIcon } from "../../../../assets/svgs/filters-icon.svg";
// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// import { Button } from "antd";
// import { Tables } from "../../../../components/Elements/Tables/Tables";
// import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-green.svg";
// import { Badge } from "../../../../components/Elements/TextStyles/Badge";
// import CreateProjects from "./DailogBoxes/CreateProjects";
// import ProjectFilter from "./DailogBoxes/ProjectFilter";
// import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
// import { getApi } from "../../../../api/api_instance";
// import { API_URLS } from "../../../../api/apiUrls";
// import dayjs from "dayjs";
// import { IoArrowBackCircleOutline } from "react-icons/io5";
// import { THEME_COLORS } from "../../../../color.js";

// const OrganizationProjects = () => {
//   const [openCreateDialog, setOpenCreateDialog] = useState(false);
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [sortOrder, setSortOrder] = useState("-createdAt");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterData, setFilterData] = useState("");
//   const [searchParams] = useSearchParams();
//   const openModal = searchParams.get("openModal") === "true";

//   const navigate = useNavigate();
//   const location = useLocation();

//   const headers = useMemo(
//     () => [
//       { label: "Sr. No.", key: "serial" },
//       { label: "Project name", key: "projectName" },
//       { label: "Start date", key: "startDate" },
//       { label: "End Date", key: "endDate" },
//       { label: "Project type", key: "projectType" },
//       { label: "Status", key: "status" },
//       { label: "Action", key: "action" },
//     ],
//     [],
//   );

//   const fetchTableData = useCallback(async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_PROJECTS(
//           currentPage,
//           pageSize,
//           sortOrder,
//           searchTerm,
//           filterData,
//         ),
//       });

//       if (response.success) {
//         setPageSize(response.limit);
//         setTotalRecords(response.total);
//         setTableData(
//           response.data.map((item, index) => ({
//             key: item._id,
//             serial: (currentPage - 1) * response.limit + index + 1,
//             projectName: item.name,
//             startDate: dayjs(item.startDate).format("DD/MM/YYYY"),
//             endDate: dayjs(item.endDate).format("DD/MM/YYYY"),
//             projectType: item.project_type,
//             status: <Badge text={item.status} />,
//             action: (
//               <EditIcon
//                 className="w-5 h-5 cursor-pointer text-[#0087A3]"
//                 onClick={() => handleForm(item)}
//               />
//             ),
//           })),
//         );
//       }
//     } catch (error) {
//       console.error("Error in fetching table data", error);
//     }
//   }, [currentPage, pageSize, sortOrder, searchTerm, openCreateDialog]);

//   const handleForm = useCallback(
//     (item) => {
//       navigate("/organization/projects/projectPage", {
//         state: { projectName: item.name, projectId: item._id },
//       });
//     },
//     [navigate],
//   );

//   const handleSort = useCallback(() => {
//     setSortOrder((prevOrder) =>
//       prevOrder === "createdAt" ? "-createdAt" : "createdAt",
//     );
//   }, []);

//   const handlePageChange = useCallback((page) => {
//     setCurrentPage(page);
//   }, []);

//   useEffect(() => {
//     fetchTableData();
//   }, [fetchTableData]);

//   useEffect(() => {
//     if (openModal) {
//       setOpenCreateDialog(true);
//       const newSearchParams = new URLSearchParams(searchParams);
//       newSearchParams.delete("openModal");
//       navigate(`${location.pathname}?${newSearchParams.toString()}`, {
//         replace: true,
//       });
//     }
//   }, [openModal]);

//   return (
//     <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       {/* Breadcrumb */}

//       <div>
//         <div className="flex flex-wrap justify-end text-[1rem] font-[Calibri] mb-0 h-5">
//           <p>Home</p>
//           <span className="mx-1">/</span>
//           <p className="text-green-700 font-semibold">Projects</p>
//         </div>

//         <div className="flex items-center gap-2 mb-1.5 text-xl font-bold">
//           <IoArrowBackCircleOutline className="w-10 h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition" />
//           <div className="text-[#06513D] font-[Calibri] text-[20px] leading-none tracking-tight">
//             Projects
//           </div>
//         </div>

//         <div className="bg-white rounded-xl shadow-md border border-[#3BA2B959] pt-6">
//           <div className="flex flex-col lg:flex-row lg:justify-between gap-4 px-4 sm:px-6 mb-4">
//             {/* TOP LEFT: TOTAL PROJECTS + SEARCHBAR (Stack on tablet/mobile) */}
//             <div className="flex flex-col sm:flex-row flex-wrap gap-4 w-full lg:w-auto">
//               <div className="bg-[#E6EEEC] border border-[#0087A3] rounded-md px-4 py-2 text-[#005E45] text-[16px] font-[Calibri] w-full sm:w-auto text-center sm:text-left">
//                 TOTAL PROJECTS {totalRecords}
//               </div>
//               <div className="w-full sm:w-auto flex-1">
//                 <SearchBar
//                   width="100%"
//                   onSearch={(value) => setSearchTerm(value)}
//                 />
//               </div>
//             </div>

//             {/* BOTTOM RIGHT: CREATE + FILTER BUTTONS (Stack on tablet/mobile) */}
//             <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full lg:w-auto">
//               <Button
//                 className="bg-[#06513D] text-[12px] text-white font-light px-4 py-5 w-full sm:w-auto"
//                 onClick={() => setOpenCreateDialog(true)}
//               >
//                 + CREATE PROJECT
//               </Button>
//               <Button
//                 className="bg-[#E6EEEC] border border-[#06513D] text-[#06513D] text-[12px] font-[Calibri] font-light px-4 py-5 w-full sm:w-auto"
//                 onClick={() => setFilterOpen(true)}
//               >
//                 <FilterIcon className="inline-block mr-1" />
//                 FILTER
//               </Button>
//             </div>
//           </div>

//           {/* Table Container */}
//           <div className="overflow-x-auto">
//             <Tables
//               data={tableData}
//               headers={headers}
//               pageSize={pageSize}
//               total={totalRecords}
//               current={currentPage}
//               onChange={handlePageChange}
//               onSort={handleSort}
//             />
//           </div>
//         </div>

//         {openCreateDialog && (
//           <CreateProjects
//             onOpen={openCreateDialog}
//             onClose={() => setOpenCreateDialog(false)}
//           />
//         )}
//         {filterOpen && (
//           <ProjectFilter
//             onOpen={filterOpen}
//             onClose={() => setFilterOpen(false)}
//             setFilterData={setTableData}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default OrganizationProjects;

// import React, { useEffect, useMemo, useState, useCallback } from "react";
// import { ReactComponent as FilterIcon } from "../../../../assets/svgs/filters-icon.svg";
// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// import { Button } from "antd";
// import { Tables } from "../../../../components/Elements/Tables/Tables";
// import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-green.svg";
// import { Badge } from "../../../../components/Elements/TextStyles/Badge";
// import CreateProjects from "./DailogBoxes/CreateProjects";
// import ProjectFilter from "./DailogBoxes/ProjectFilter";
// import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
// import { getApi } from "../../../../api/api_instance";
// import { API_URLS } from "../../../../api/apiUrls";
// import dayjs from "dayjs";
// import { IoArrowBackCircleOutline } from "react-icons/io5";
// import { THEME_COLORS } from "../../../../color.js";
// import { Select } from "antd";
// import { CopyOutlined as CopyIcon } from "@ant-design/icons";
// import "./project.css";
// const { Option } = Select;

// const OrganizationProjects = () => {
//   const [openCreateDialog, setOpenCreateDialog] = useState(false);
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [sortOrder, setSortOrder] = useState("-createdAt");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterData, setFilterData] = useState("");
//   const [searchParams] = useSearchParams();
//   const openModal = searchParams.get("openModal") === "true";

//   const navigate = useNavigate();
//   const location = useLocation();

//   const headers = useMemo(
//     () => [
//       { label: "Sr. No.", key: "serial", align: "center" },
//       { label: "Project name", key: "projectName", align: "center" },
//       { label: "Start date", key: "startDate", align: "center" },
//       { label: "End Date", key: "endDate", align: "center" },
//       { label: "Project type", key: "projectType", align: "center" },
//       { label: "Status", key: "status", align: "center" },
//       { label: "Action", key: "action", align: "center" },
//     ],
//     [],
//   );

//   const fetchTableData = useCallback(async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_PROJECTS(
//           currentPage,
//           pageSize,
//           sortOrder,
//           searchTerm,
//           filterData,
//         ),
//       });

//       if (response.success) {
//         setPageSize(response.limit);
//         setTotalRecords(response.total);
//         setTableData(
//           response.data.map((item, index) => ({

//             key: item._id,
//             serial: (currentPage - 1) * response.limit + index + 1,
//             projectName: (
//               <div
//                 style={{
//                   textAlign: "center",
//                   wordWrap: "break-word",
//                   wordBreak: "break-word",
//                   whiteSpace: "normal",
//                   maxWidth: "200px",
//                   margin: "0 auto",
//                 }}
//               >
//                 {item.name}
//               </div>
//             ),
//             startDate: (
//               <div style={{ textAlign: "center" }}>
//                 {dayjs(item.startDate).format("DD/MM/YYYY")}
//               </div>
//             ),
//             endDate: (
//               <div style={{ textAlign: "center" }}>
//                 {dayjs(item.endDate).format("DD/MM/YYYY")}
//               </div>
//             ),
//             projectType: (
//               <div
//                 style={{
//                   textAlign: "center",
//                   wordWrap: "break-word",
//                   wordBreak: "break-word",
//                   whiteSpace: "normal",
//                   maxWidth: "150px",
//                   margin: "0 auto",
//                 }}
//               >
//                 {item.project_type}
//               </div>
//             ),
//             status: (
//               <div
//                 style={{
//                   textAlign: "center",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                 }}
//               >
//                 <Badge text={item.status} />
//               </div>
//             ),
//             // Store original item data for mobile view
//             originalData: item,
//             action: (
//               <div
//                 style={{
//                   textAlign: "center",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                 }}
//               >
//                 <EditIcon
//                   className="w-5 h-5 cursor-pointer text-[#0087A3]"
//                   style={{border:"2px solid red"}}
//                   onClick={() => handleForm(item)}
//                 />
//               </div>
//             ),

//           })),
//         );
//       }
//     } catch (error) {
//       console.error("Error in fetching table data", error);
//     }
//   }, [
//     currentPage,
//     pageSize,
//     sortOrder,
//     searchTerm,
//     filterData,
//     openCreateDialog,
//   ]);

//   // const handleForm = useCallback(
//   //   (item) => {
//   //     // For mobile view, item structure is different
//   //     const projectName = item.projectName || item.name;
//   //     const projectId = item.key || item._id;

//   //     navigate("/organization/projects/projectPage", {
//   //       state: { projectName, projectId },
//   //     });
//   //   },
//   //   [navigate],
//   // );
//   const handleForm = useCallback(
//     (item) => {
//       // item.projectName is JSX, use originalData or item.name for string
//       const projectName = item.originalData?.name || item.name;
//       const projectId = item.key || item._id;

//       navigate("/organization/projects/projectPage", {
//         state: { projectName, projectId },
//       });
//     },
//     [navigate],
//   );

//   const handleSort = useCallback(() => {
//     setSortOrder((prevOrder) =>
//       prevOrder === "createdAt" ? "-createdAt" : "createdAt",
//     );
//   }, []);

//   // Updated handlePageChange for both desktop and mobile
//   const handlePageChange = useCallback((page) => {
//     setCurrentPage(page);
//   }, []);

//   // Mobile pagination handlers
//   const handleMobilePrevious = useCallback(() => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   }, [currentPage]);

//   const handleMobileNext = useCallback(() => {
//     const totalPages = Math.ceil(totalRecords / pageSize);
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   }, [currentPage, totalRecords, pageSize]);

//   useEffect(() => {
//     fetchTableData();
//   }, [fetchTableData]);

//   useEffect(() => {
//     if (openModal) {
//       setOpenCreateDialog(true);
//       const newSearchParams = new URLSearchParams(searchParams);
//       newSearchParams.delete("openModal");
//       navigate(`${location.pathname}?${newSearchParams.toString()}`, {
//         replace: true,
//       });
//     }
//   }, [openModal]);

//   // Calculate total pages based on API response
//   const totalPages = Math.ceil(totalRecords / pageSize);

//   // Mobile card data - showing current page data directly from API
//   const mobileCardData = useMemo(() => {
//     return tableData;
//   }, [tableData]);

//   if (filterData && filterData.length) {
//     setTableData(filterData);
//     return;
//   }

//   return (
//     <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       <div>
//         <div className="flex flex-wrap justify-end text-[1rem] font-[Calibri] mb-0 h-5">
//           <p>Home</p>
//           <span className="mx-1">/</span>
//           <p className="text-green-700 font-semibold">Projects</p>
//         </div>

//         <div className="flex items-center gap-2 mb-1.5 text-xl font-bold">
//           {/* <IoArrowBackCircleOutline className="w-10 h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition" />

//           */}
//           <div className="text-[#06513D] font-[Calibri] text-[20px] leading-none tracking-tight">
//             Projects
//           </div>
//         </div>

//         <div className="bg-white rounded-xl shadow-md border border-[#3BA2B959] pt-6">
//           <div className="flex flex-col lg:flex-row lg:justify-between gap-4 px-4 sm:px-6 mb-4">
//             <div className="flex flex-col sm:flex-row flex-wrap gap-4 w-full lg:w-auto">
//               {/* <div className="sm:w-1/2 lg:w-auto h-9 p-2 border border-[#06513D] rounded-md bg-[#B6D4D933] text-[#005E45] text-sm font-light font-[Calibri] text-center sm:text-left">
//                 TOTAL PROJECTS {totalRecords}
//               </div> */}
//               <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full lg:w-auto">
//                 <button
//                   className="bg-[#B6D4D933] rounded-md border border-[#06513D]  text-[12px] text-[#005E45] font-light px-4 py-3 w-full sm:w-auto"
//                   onClick={() => setOpenCreateDialog(true)}
//                 >
//                   TOTAL PROJECTS {totalRecords}
//                 </button>
//               </div>
//               <div className="w-full sm:w-auto flex-1">
//                 <SearchBar
//                   width="100%"
//                   onSearch={(value) => setSearchTerm(value)}
//                 />
//               </div>
//             </div>

//             <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full lg:w-auto">
//               <button
//                 className="bg-[#06513D] rounded-md hover:bg-[#06513DCC] text-[12px] text-white font-light px-4 py-3 w-full sm:w-auto"
//                 onClick={() => setOpenCreateDialog(true)}
//               >
//                 + CREATE PROJECT
//               </button>

//               <button
//                 className="bg-[#E6EEEC] border rounded-md border-[#06513D] text-[#06513D] text-[12px] font-[Calibri] font-light px-4 py-3 w-full sm:w-auto"
//                 onClick={() => setFilterOpen(true)}
//               >
//                 <FilterIcon className="inline-block mr-1" />
//                 FILTER
//               </button>
//             </div>
//           </div>

//           {/* Mobile View */}
//           <div className="block lg:hidden px-4 sm:px-6">
//             {mobileCardData.length > 0 ? (
//               <>
//                 {mobileCardData.map((item, index) => (
//                   <div
//                     key={item.key}
//                     className="bg-white rounded-xl shadow-lg border border-gray-100 p-5 mb-4 transform transition-all duration-300 hover:shadow-xl hover:scale-[1.02] hover:border-[#3BA2B9] animate-slideInUp"
//                     style={{
//                       animationDelay: `${index * 0.1}s`,
//                       background:
//                         "linear-gradient(135deg, #ffffff 0%, #f8fffe 100%)",
//                       border: "1px solid #e0f2f1",
//                     }}
//                   >
//                     <div className="flex justify-between items-center mb-4 pb-3 border-b border-gray-100">
//                       <span className="bg-gradient-to-r from-[#06513D] to-[#3BA2B9] text-white text-sm font-bold px-4 py-2 rounded-full">
//                         #{item.serial}
//                       </span>
//                     </div>

//                     <div className="flex justify-between items-start mb-4">
//                       <span className="text-sm font-semibold text-gray-600 min-w-[100px]">
//                         Project Name:
//                       </span>
//                       <span className="text-sm font-medium text-gray-800 text-right flex-1 ml-3">
//                         {item.originalData?.name || item.projectName}
//                       </span>
//                     </div>

//                     <div className="flex justify-between items-center mb-4">
//                       <span className="text-sm font-semibold text-gray-600">
//                         Start:
//                       </span>
//                       <span className="text-sm font-medium text-gray-800 bg-gray-100 px-3 py-1 rounded-full">
//                         {dayjs(item.originalData?.startDate).format(
//                           "DD/MM/YYYY",
//                         )}
//                       </span>
//                     </div>
//                     <div className="flex justify-between items-center mb-4">
//                       <span className="text-sm font-semibold text-gray-600">
//                         End:
//                       </span>
//                       <span className="text-sm font-medium text-gray-800 bg-blue-50 px-3 py-1 rounded-full text-blue-700">
//                         {dayjs(item.originalData?.endDate).format("DD/MM/YYYY")}
//                       </span>
//                     </div>
//                     <div className="flex justify-between items-center mb-4">
//                       <span className="text-sm font-semibold text-gray-600">
//                         Type:
//                       </span>
//                       <span className="text-sm font-medium text-gray-800 bg-green-50 px-3 py-1 rounded-full text-green-700">
//                         {item.originalData?.project_type}
//                       </span>
//                     </div>

//                     <div className="flex justify-between items-center pt-4 border-t border-gray-100">
//                       <span className="text-sm font-semibold text-gray-600">
//                         Status:
//                       </span>
//                       <div className="flex items-center gap-3">
//                         <Badge text={item.originalData?.status} />
//                         <EditIcon
//                           className="w-5 h-5 cursor-pointer text-[#0087A3]"
//                           onClick={() => handleForm(item)}
//                         />
//                         <button className="p-2 rounded-full bg-gray-100 hover:bg-[#06513D] hover:text-white transition-all duration-300 transform hover:scale-110">
//                           <CopyIcon style={{ fontSize: "16px" }} />
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 ))}

//                 {/* Enhanced Mobile Pagination Controls */}
//                 <div className="flex justify-center items-center mt-6 mb-4">
//                   <div className="flex items-center gap-2 bg-white rounded-lg shadow-md p-2 border border-gray-200">
//                     <Button
//                       onClick={handleMobilePrevious}
//                       disabled={currentPage === 1}
//                       className={`px-4 py-2 rounded-md transition-all duration-300 ${
//                         currentPage === 1
//                           ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                           : "bg-[#06513D] text-white hover:bg-[#04422F] hover:scale-105"
//                       }`}
//                     >
//                       Previous
//                     </Button>

//                     <div className="flex items-center gap-2 px-4">
//                       <span className="text-sm text-gray-600">Page</span>
//                       <span className="bg-[#06513D] text-white px-3 py-1 rounded-full text-sm font-medium">
//                         {currentPage}
//                       </span>
//                       <span className="text-sm text-gray-600">of</span>
//                       <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm font-medium">
//                         {totalPages}
//                       </span>
//                     </div>

//                     <Button
//                       onClick={handleMobileNext}
//                       disabled={currentPage === totalPages}
//                       className={`px-4 py-2 rounded-md transition-all duration-300 ${
//                         currentPage === totalPages
//                           ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                           : "bg-[#06513D] text-white hover:bg-[#04422F] hover:scale-105"
//                       }`}
//                     >
//                       Next
//                     </Button>
//                   </div>
//                 </div>

//                 {/* Mobile Pagination Info */}
//                 <div className="text-center text-sm text-gray-600 mb-4">
//                   Showing {(currentPage - 1) * pageSize + 1} to{" "}
//                   {Math.min(currentPage * pageSize, totalRecords)} of{" "}
//                   {totalRecords} projects
//                 </div>
//               </>
//             ) : (
//               <div className="text-center py-8 text-gray-500">
//                 <p>No projects found</p>
//               </div>
//             )}
//           </div>

//           {/* Desktop Table View */}
//           <div className="hidden lg:block overflow-x-auto">
//             <Tables
//               data={tableData}
//               headers={headers}
//               pageSize={pageSize}
//               total={totalRecords}
//               current={currentPage}
//               onChange={handlePageChange}
//               onSort={handleSort}
//               style={{
//                 "--table-header-text-align": "center",
//               }}
//               className="center-aligned-table"
//             />
//           </div>
//         </div>

//         {openCreateDialog && (
//           <CreateProjects
//             onOpen={openCreateDialog}
//             onClose={() => setOpenCreateDialog(false)}
//           />
//         )}
//         {filterOpen && (
//           <ProjectFilter
//             onOpen={filterOpen}
//             onClose={() => setFilterOpen(false)}
//             setFilterData={setFilterData}
//           />
//         )}
//       </div>

//       {/* Add custom CSS for table styling */}
//       <style jsx>{`
//         .center-aligned-table .ant-table-tbody > tr > td {
//           text-align: center !important;
//           word-wrap: break-word !important;
//           word-break: break-word !important;
//           white-space: normal !important;
//           padding: 12px 8px !important;
//         }

//         .center-aligned-table .ant-table-thead > tr > th {
//           text-align: center !important;
//         }

//         .center-aligned-table .ant-table-cell {
//           vertical-align: middle !important;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default OrganizationProjects;

import React, { useEffect, useMemo, useState, useCallback } from "react";
import { ReactComponent as FilterIcon } from "../../../../assets/svgs/filters-icon.svg";
import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
import { Button } from "antd";
import { Tables } from "../../../../components/Elements/Tables/Tables";
import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-green.svg";
import { Badge } from "../../../../components/Elements/TextStyles/Badge";
import CreateProjects from "./DailogBoxes/CreateProjects";
import ProjectFilter from "./DailogBoxes/ProjectFilter";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { getApi } from "../../../../api/api_instance";
import { API_URLS } from "../../../../api/apiUrls";
import dayjs from "dayjs";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { THEME_COLORS } from "../../../../color.js";
import { Select, message, Empty } from "antd";
import { CopyOutlined as CopyIcon } from "@ant-design/icons";
import "./project.css";
import PopupCard from "../../../Auth/PopupCard.jsx";
import PermissionForm from "../../../Auth/PermissionForm.jsx";
import { useSelector } from "react-redux";
import { useDebounce } from "../../../../hooks/debouncing.js";
const { Option } = Select;

const OrganizationProjects = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage || 1,
  );
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortOrder, setSortOrder] = useState("-createdAt");
  const [searchTerm, setSearchTerm] = useState(
    location.state?.searchTerm || "",
  );
  const [filterData, setFilterData] = useState(
    location.state?.filterData || {},
  );
  const [searchParams] = useSearchParams();
  const [warningPopup, setWarningPopup] = useState(false);
  const [startDate, setStartDate] = useState(location.state?.startDate || "");
  const [endDate, setEndDate] = useState(location.state?.endDate || "");
  const [status, setStatus] = useState(location.state?.status || "");
  const [projectType, setProjectType] = useState(
    location.state?.projectType || null,
  );
  const openModal = searchParams.get("openModal") === "true";
  const [showPermission, setPermission] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;

  const debouncedSearch = useDebounce(searchTerm, 500);

  const isDbEmpty = useMemo(() => {
    const hasNoFilters =
      !debouncedSearch && !startDate && !endDate && !status && !projectType;
    return hasNoFilters && totalRecords === 0;
  }, [debouncedSearch, startDate, endDate, status, projectType, totalRecords]);
  // Automatically show permission form when component mounts if not completed
  useEffect(() => {
    if (!isPermissionCompleted) {
      setPermission(true);
    }
  }, [isPermissionCompleted]);
  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial", align: "center" },
      { label: "Project name", key: "projectName", align: "center" },
      { label: "Start date", key: "startDate", align: "center" },
      { label: "End date", key: "endDate", align: "center" },
      { label: "Type of service", key: "projectType", align: "center" },
      { label: "Status", key: "status", align: "center" },
      { label: "Action", key: "action", align: "center" },
    ],
    [],
  );

  const fetchTableData = useCallback(async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_PROJECTS(
          currentPage,
          pageSize,
          sortOrder,
          debouncedSearch,
          filterData,
        ),
      });

      if (response.success) {
        setPageSize(response.limit);
        setTotalRecords(response.total);
        setTableData(
          response.data.map((item, index) => ({
            key: item._id,
            serial: (
              <div className="text-center">
                {(currentPage - 1) * response.limit + index + 1}
              </div>
            ),
            projectName: (
              <div
                style={{
                  textAlign: "center",
                  wordWrap: "break-word",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  maxWidth: "200px",
                  margin: "0 auto",
                }}
                title=""
              >
                {item.name}
              </div>
            ),
            startDate: (
              <div title="" style={{ textAlign: "center" }}>
                {dayjs(item.startDate).format("DD-MM-YYYY")}
              </div>
            ),
            endDate: (
              <div title="" style={{ textAlign: "center" }}>
                {item.approval?.status === "accept"
                  ? dayjs(item.endDate).format("DD-MM-YYYY")
                  : "-"}
              </div>
            ),
            projectType: (
              <div
                style={{
                  textAlign: "center",
                  wordWrap: "break-word",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  maxWidth: "150px",
                  margin: "0 auto",
                }}
                title=""
              >
                {item.project_type}
              </div>
            ),
            status: (
              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                title=""
              >
                <Badge text={item.status} />
              </div>
            ),
            // Store original item data for mobile view
            originalData: item,
            action: (
              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                title=""
              >
                <EditIcon
                  className={`w-5 h-5 cursor-pointer ${
                    item.isActive === false
                      ? "text-gray-400 cursor-not-allowed opacity-50"
                      : "text-[#0087A3] hover:text-[#006b87]"
                  }`}
                  onClick={() => handleEditClick(item)}
                />
              </div>
            ),
          })),
        );
      }
    } catch (error) {
      console.error("Error in fetching table data", error);
    }
  }, [
    currentPage,
    pageSize,
    sortOrder,
    debouncedSearch,
    filterData,
    openCreateDialog,
  ]);

  // Updated handleEditClick function with conditional logic
  // const handleEditClick = useCallback((item) => {
  //   // Check if isActive is false
  //   if (item.isActive === false) {
  //     message.warning("This project is not active and cannot be edited.");
  //     return;
  //   }

  //   // If active or isActive is not defined (default behavior), proceed with navigation
  //   handleForm(item);
  // }, []);

  const handleForm = useCallback(
    (item) => {
      // item.projectName is JSX, use originalData or item.name for string
      const projectName = item.originalData?.name || item.name;
      const projectId = item.key || item._id;

      navigate("/organization/projects/projectPage", {
        state: {
          projectName,
          projectId,
          source: "projects-list",
          currentPage,
          searchTerm,
          filterData,
          startDate,
          endDate,
          status,
          projectType,
        },
      });
    },
    [
      navigate,
      currentPage,
      searchTerm,
      filterData,
      startDate,
      endDate,
      status,
      projectType,
    ],
  );

  const handleEditClick = useCallback(
    (item) => {
      if (item.isActive === false) {
        setWarningPopup(true); // Show popup
        return;
      }
      handleForm(item);
    },
    [handleForm],
  );

  const handleSort = useCallback(() => {
    setSortOrder((prevOrder) =>
      prevOrder === "createdAt" ? "-createdAt" : "createdAt",
    );
  }, []);

  // Updated handlePageChange for both desktop and mobile
  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  // Mobile pagination handlers
  const handleMobilePrevious = useCallback(() => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  }, [currentPage]);

  const handleMobileNext = useCallback(() => {
    const totalPages = Math.ceil(totalRecords / pageSize);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  }, [currentPage, totalRecords, pageSize]);

  useEffect(() => {
    fetchTableData();
  }, [fetchTableData]);

  useEffect(() => {
    if (openModal) {
      setOpenCreateDialog(true);
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete("openModal");
      navigate(`${location.pathname}?${newSearchParams.toString()}`, {
        replace: true,
      });
    }
  }, [openModal]);

  // Calculate total pages based on API response
  const totalPages = Math.ceil(totalRecords / pageSize);

  // Mobile card data - showing current page data directly from API
  const mobileCardData = useMemo(() => {
    return tableData;
  }, [tableData]);

  if (filterData && filterData.length) {
    setTableData(filterData);
    return;
  }

  return (
    <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      {!isPermissionCompleted && showPermission && (
        <PermissionForm
          permissionConClose={() => setPermission(false)}
          //  permissionConClose={handlePermissionClose}
          // isClosable={isPermissionCompleted} // Pass prop to control close button visibility
        />
      )}
      <div>
        <div className="flex flex-wrap justify-end text-[1rem] font-[Calibri] mb-0 h-5">
          <p>Home</p>
          <span className="mx-1">/</span>
          <p className="text-green-700 font-semibold">Projects</p>
        </div>

        <div className="flex items-center gap-2 mb-1.5 text-xl font-bold">
          {/* <IoArrowBackCircleOutline className="w-10 h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition" />
         
          */}
          <div className="text-[#06513D] font-[Calibri] text-[20px] leading-none tracking-tight">
            Projects
          </div>
        </div>

        <div className="overflow-hidden bg-white rounded-xl shadow-md border border-[#3BA2B959] pt-6">
          <div className="flex flex-col lg:flex-row lg:justify-between gap-4 px-4 sm:px-6 mb-4">
            <div className="flex flex-col sm:flex-row flex-wrap gap-4 w-full lg:w-auto">
              {/* <div className="sm:w-1/2 lg:w-auto h-9 p-2 border border-[#06513D] rounded-md bg-[#B6D4D933] text-[#005E45] text-sm font-light font-[Calibri] text-center sm:text-left">
                    TOTAL PROJECTS {totalRecords}
                  </div> */}
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full lg:w-auto">
                <button
                  className="bg-[#B6D4D933] rounded-md border border-[#06513D]  text-[12px] text-[#005E45] font-light px-4 py-3 w-full sm:w-auto"
                  onClick={() => setOpenCreateDialog(true)}
                >
                  TOTAL PROJECTS {totalRecords}
                </button>
              </div>
              <div className="w-full sm:w-auto flex-1">
                <SearchBar
                  width="100%"
                  onSearch={(value) => {
                    setSearchTerm(value);
                    setCurrentPage(1); // Add this line
                  }}
                />
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full lg:w-auto">
              {!isDbEmpty && (
                <button
                  className="bg-[#06513D] rounded-md hover:bg-[#387464] text-[12px] text-white font-light px-4 py-3 w-full sm:w-auto"
                  onClick={() => setOpenCreateDialog(true)}
                >
                  + CREATE PROJECT
                </button>
              )}

              <button
                className="bg-[#E6EDEB] hover:bg-[#F8F8F8] border rounded-md  border-[#06513D] text-[#06513D] text-[12px] font-[Calibri] font-light px-4 py-3 w-full sm:w-auto"
                onClick={() => setFilterOpen(true)}
              >
                <FilterIcon className="inline-block mr-1" />
                FILTER
              </button>
            </div>
          </div>

          {/* Mobile View */}
          <div className="block lg:hidden px-4 sm:px-6">
            {mobileCardData.length > 0 ? (
              <>
                {mobileCardData.map((item, index) => (
                  <div
                    key={item.key}
                    className="bg-white rounded-xl shadow-lg border border-gray-100 p-5 mb-4 transform transition-all duration-300 hover:shadow-xl hover:scale-[1.02] hover:border-[#3BA2B9] animate-slideInUp"
                    style={{
                      animationDelay: `${index * 0.1}s`,
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f8fffe 100%)",
                      border: "1px solid #e0f2f1",
                    }}
                  >
                    <div className="flex justify-between items-center mb-4 pb-3 border-b border-gray-100">
                      <span className="bg-gradient-to-r from-[#06513D] to-[#3BA2B9] text-white text-sm font-bold px-4 py-2 rounded-full">
                        #{item.serial}
                      </span>
                    </div>

                    <div className="flex justify-between items-start mb-4">
                      <span className="text-sm font-semibold text-gray-600 min-w-[100px]">
                        Project Name:
                      </span>
                      <span className="text-sm font-medium text-gray-800 text-right flex-1 ml-3">
                        {item.originalData?.name || item.projectName}
                      </span>
                    </div>

                    <div className="flex justify-between items-center mb-4">
                      <span className="text-sm font-semibold text-gray-600">
                        Start:
                      </span>
                      <span className="text-sm font-medium text-gray-800 bg-gray-100 px-3 py-1 rounded-full">
                        {dayjs(item.originalData?.startDate).format(
                          "DD/MM/YYYY",
                        )}
                      </span>
                    </div>
                    <div className="flex justify-between items-center mb-4">
                      <span className="text-sm font-semibold text-gray-600">
                        End:
                      </span>
                      <span className="text-sm font-medium text-gray-800 bg-blue-50 px-3 py-1 rounded-full text-blue-700">
                        {dayjs(item.originalData?.endDate).format("DD/MM/YYYY")}
                      </span>
                    </div>
                    <div className="flex justify-between items-center mb-4">
                      <span className="text-sm font-semibold text-gray-600">
                        Type:
                      </span>
                      <span className="text-sm font-medium text-gray-800 bg-green-50 px-3 py-1 rounded-full text-green-700">
                        {item.originalData?.project_type}
                      </span>
                    </div>

                    <div className="flex justify-between items-center pt-4 border-t border-gray-100">
                      <span className="text-sm font-semibold text-gray-600">
                        Status:
                      </span>
                      <div className="flex items-center gap-3">
                        <Badge text={item.originalData?.status} />
                        <EditIcon
                          className={`w-5 h-5 cursor-pointer ${
                            item.originalData?.isActive === false
                              ? "text-gray-400 cursor-not-allowed opacity-50"
                              : "text-[#0087A3] hover:text-[#006b87]"
                          }`}
                          onClick={() =>
                            handleEditClick(item.originalData || item)
                          }
                        />
                        <button className="p-2 rounded-full bg-gray-100 hover:bg-[#06513D] hover:text-white transition-all duration-300 transform hover:scale-110">
                          <CopyIcon style={{ fontSize: "16px" }} />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}

                {/* Enhanced Mobile Pagination Controls */}
                <div className="flex justify-center items-center mt-6 mb-4">
                  <div className="flex items-center gap-2 bg-white rounded-lg shadow-md p-2 border border-gray-200">
                    <Button
                      onClick={handleMobilePrevious}
                      disabled={currentPage === 1}
                      className={`px-4 py-2 rounded-md transition-all duration-300 ${
                        currentPage === 1
                          ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                          : "bg-[#06513D] text-white hover:bg-[#04422F] hover:scale-105"
                      }`}
                    >
                      Previous
                    </Button>

                    <div className="flex items-center gap-2 px-4">
                      <span className="text-sm text-gray-600">Page</span>
                      <span className="bg-[#06513D] text-white px-3 py-1 rounded-full text-sm font-medium">
                        {currentPage}
                      </span>
                      <span className="text-sm text-gray-600">of</span>
                      <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm font-medium">
                        {totalPages}
                      </span>
                    </div>

                    <Button
                      onClick={handleMobileNext}
                      disabled={currentPage === totalPages}
                      className={`px-4 py-2 rounded-md transition-all duration-300 ${
                        currentPage === totalPages
                          ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                          : "bg-[#06513D] text-white hover:bg-[#04422F] hover:scale-105"
                      }`}
                    >
                      Next
                    </Button>
                  </div>
                </div>

                {/* Mobile Pagination Info */}
                <div className="text-center text-sm text-gray-600 mb-4">
                  Showing {(currentPage - 1) * pageSize + 1} to{" "}
                  {Math.min(currentPage * pageSize, totalRecords)} of{" "}
                  {totalRecords} projects
                </div>
              </>
            ) : (
              <div className="text-center py-12 flex flex-col items-center">
                {isDbEmpty ? (
                  <button
                    className="bg-[#06513D] rounded-md hover:bg-[#387464] text-[12px] text-white font-light px-4 py-3"
                    onClick={() => setOpenCreateDialog(true)}
                  >
                    + CREATE PROJECT
                  </button>
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={
                      <div className="flex flex-col items-center justify-center pt-2">
                        <span className="text-gray-400">No projects found</span>
                      </div>
                    }
                  />
                )}
              </div>
            )}
          </div>

          {/* Desktop Table View */}
          <div className="hidden lg:block overflow-x-auto">
            <Tables
              data={tableData}
              headers={headers}
              pageSize={pageSize}
              total={totalRecords}
              current={currentPage}
              onChange={handlePageChange}
              onSort={handleSort}
              style={{
                "--table-header-text-align": "center",
              }}
              className="center-aligned-table"
              emptyText={
                isDbEmpty ? (
                  <div className="flex flex-col items-center justify-center py-8">
                    <button
                      className="bg-[#06513D] rounded-md hover:bg-[#387464] text-[12px] text-white font-light px-4 py-3"
                      onClick={() => setOpenCreateDialog(true)}
                    >
                      + CREATE PROJECT
                    </button>
                  </div>
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={
                      <div className="flex flex-col items-center justify-center pt-2 pb-6">
                        <span className="text-gray-400">No data</span>
                      </div>
                    }
                  />
                )
              }
            />
          </div>
        </div>

        {openCreateDialog && (
          <CreateProjects
            onOpen={openCreateDialog}
            onClose={() => setOpenCreateDialog(false)}
          />
        )}
        {filterOpen && (
          <ProjectFilter
            // onOpen={filterOpen}
            // // onClose={() => setFilterData}
            // onClose={() => setFilterOpen(false)}
            // setFilterData={setFilterData}
            // filterData={filterData}

            onOpen={filterOpen}
            onClose={() => setFilterOpen(false)}
            setFilterData={(data) => {
              setFilterData(data);
              setCurrentPage(1); // Add this when filter is applied
            }}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            status={status}
            setStatus={setStatus}
            projectType={projectType}
            setProjectType={setProjectType}
          />
        )}

        {/* const [filterData, setFilterData] = useState({});

<ProjectFilter
  onOpen={isFilterOpen}
  onClose={() => setIsFilterOpen(false)}
  setFilterData={setFilterData}
  filterData={filterData}   // <-- pass existing data
/> */}
      </div>
      {warningPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[9999]">
          <PopupCard
            type="warning"
            title="Warning"
            message={`You do not have the required permission to view or access this form. Please get in touch with the OffsetGo Support Team.

            📞 1800 572 2929
            ✉️ carburn@offsetgo.earth`}
            onCancel={() => setWarningPopup(false)}
            cancelText="OK"
          />
        </div>
      )}

      {/* Add custom CSS for table styling */}
      <style jsx>{`
        .center-aligned-table .ant-table-tbody > tr > td {
          text-align: center !important;
          word-wrap: break-word !important;
          word-break: break-word !important;
          white-space: normal !important;
          padding: 12px 8px !important;
        }

        .center-aligned-table .ant-table-thead > tr > th {
          text-align: center !important;
        }

        .center-aligned-table .ant-table-cell {
          vertical-align: middle !important;
        }
      `}</style>
    </div>
  );
};

export default OrganizationProjects;
